import { render, staticRenderFns } from "./CreateColorsForm.vue?vue&type=template&id=c9c558bc&"
import script from "./CreateColorsForm.vue?vue&type=script&lang=js&"
export * from "./CreateColorsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports